/** @format */

import { Amplify } from 'aws-amplify';

export interface CustomRestApiConfig {
  endpoint: string;
  name: string;
  region?: string;
}

export interface ConfigureAmplifyOptions {
  customRestApi?: CustomRestApiConfig;
  onConfigured?: () => void;
}

export type AmplifyConfiguration = Record<string, any>;

export function configureAmplify(
  baseConfig: AmplifyConfiguration,
  options: ConfigureAmplifyOptions = {},
): AmplifyConfiguration {
  const config: AmplifyConfiguration = { ...baseConfig };
  const region = `${config['aws_project_region'] ?? options.customRestApi?.region ?? ''}`.trim();

  if (region) config['aws_project_region'] = region;

  if (options.customRestApi?.endpoint) {
    config['aws_cloud_logic_custom'] = [
      {
        name: options.customRestApi.name,
        endpoint: options.customRestApi.endpoint,
        region: region || options.customRestApi.region,
      },
    ];
  }

  Amplify.configure(config);
  options.onConfigured?.();

  return config;
}
